import { z } from "zod";

export const FavoriteFieldsSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  creationDate: z.string(),
});
export const PartialFavoriteFieldsSchema = FavoriteFieldsSchema.deepPartial();

export const FavoriteExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
});
export const PartialFavoriteExtraFieldsSchema =
  FavoriteExtraFieldsSchema.deepPartial();

export const FavoriteSchema = z.intersection(
  FavoriteFieldsSchema,
  FavoriteExtraFieldsSchema
);

export type FavoriteFields = z.infer<typeof FavoriteFieldsSchema>;
export type PartialFavoriteFields = z.infer<typeof PartialFavoriteFieldsSchema>;
export type FavoriteExtraFields = z.infer<typeof FavoriteExtraFieldsSchema>;
export type PartialFavoriteExtraFields = z.infer<
  typeof PartialFavoriteExtraFieldsSchema
>;
export type Favorite = z.infer<typeof FavoriteSchema>;
